import React from "react";
import { Modal, Form as FormLayout } from "react-bootstrap";
import cogoToast from "cogo-toast";
import { Formik, Form } from "formik";
import * as Yup from "yup"
import { useUpdatePlanMutation } from "../../../../../redux/apiSlice";
import TextAreaInput from "../../../Common/components/text-area-input";
import TextInput from "../../../Common/components/text-input";

export const EditPlanModal = ({ showEditPlanModal, onHide, planDetails }) => {
    const [
        updatePlan, // This is the mutation trigger
        {
            isLoading: isUpdating
        }, // This is the destructured mutation result
    ] = useUpdatePlanMutation()

    /* Change User Group */
    const onSubmit = (values) => {
        updatePlan({
            planId: planDetails.planId,
            ...values
        })
       
            .unwrap()
            .then(() => {
                cogoToast.success("Created 'Update Plan' Action Successfully")
                onHide()
            })
         
    }

    return (
        <Modal
            show={showEditPlanModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isUpdating ? "static" : true}
            keyboard={!isUpdating}
        >
            <Formik
                initialValues={
                    planDetails ? {
                        planName: planDetails.planName,
                        planDescription: planDetails.planDescription,
                        tenor: planDetails.tenor,
                        interestRate: planDetails.rate,
                        maximumAmount: planDetails.maximumAmount,
                        minimumAmount: planDetails.minimumAmount,
                        currency: planDetails.currency
                    } : 
                    null
                        }
                validationSchema={
                    Yup.object({

                        name: Yup.string(),
                        description: Yup.string(),
                        tenure: Yup.number(),
                        rate: Yup.number(),
                        maximumAmount: Yup.number(),
                        minimumAmount: Yup.number(),
                        currency: Yup.string()
                    })
                }
                onSubmit={(values) => onSubmit(values)}
            >
                <Form>
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {`Edit ${planDetails ?planDetails.planName :null} plan`}
                        </Modal.Title>
                        <button type="button" className="close" onClick={onHide}>
                            <span aria-hidden="true" className="d-block">×</span>
                            <span className="sr-only">Close</span>
                        </button>
                    </Modal.Header>

                    <Modal.Body style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
                        <FormLayout.Row>
                            <TextInput
                                label="Name*"
                                name="planName"
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <TextAreaInput
                                label="Description*"
                                name="planDescription"
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <TextAreaInput
                                label="Currency*"
                                name="currency"
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <TextInput
                                label="Tenure*"
                                name="tenor"
                                type="number"
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <TextInput
                                label="Interest Rate*"
                                name="interestRate"
                                type="number"
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <TextInput
                                label="Maximum amount*"
                                name="maximumAmount"
                                type="number"
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <TextInput
                                label="Minimum amount*"
                                name="minimumAmount"
                                type="number"
                            />
                        </FormLayout.Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            onClick={onHide}
                            disabled={isUpdating}
                            className="btn btn-light btn-elevate px-4"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={isUpdating}
                            className="btn btn-primary btn-elevate px-4 ml-4"
                        >
                            Update
                        </button>
                    </Modal.Footer>
                </Form>
            </Formik>
        </Modal >
    );
}
